// export const BASE_URL = 'http://127.0.0.1:5000/api/v1';
// live
export const BASE_URL = 'https://ff-dash.oroojo.com/api/v1';